import React from 'react';
import { useSelector } from 'react-redux';
import { Loader } from './Loader';
export var Schemable = function (_a) {
    var children = _a.children;
    var schema = useSelector(function (state) { return state.schema; });
    return schema ? React.createElement("div", null, children) : React.createElement(Loader, { align: "center" });
};
